<template>
<div class="chapter">
<div class="inner_page">
<div class="media-group"><img alt="" src="images/9000f160coverc01a.jpg" width="82.75862%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?790a6cda